<template>
  <div class="bg-gray-100 dark:bg-gray-800 p-5">
    <p class="text-center dark:text-light-1 text-dark-1">
      Made with 💙 by
      <a
        class="dark:text-light-1 text-dark-1 dark:hover:text-light-4 hover:text-light-4 no-underline font-bold"
        href="https://github.com/tonalmathew"
        >tonalmathew</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  name: "footer",
};
</script>
